import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sun, Moon, Monitor } from 'lucide-react';
import { useSettingsStore } from '../lib/store';

export default function ParamsPage() {
  const navigate = useNavigate();
  const { themePreference, setThemePreference } = useSettingsStore();

  const themeOptions: Array<{ key: 'system' | 'light' | 'dark'; icon: typeof Sun; label: string }> = [
    { key: 'light', icon: Sun, label: 'Clair' },
    { key: 'dark', icon: Moon, label: 'Sombre' },
    { key: 'system', icon: Monitor, label: 'Systeme' },
  ];

  return (
    <div className="min-h-screen flex flex-col safe-area-inset relative">
      {/* Header */}
      <header className="flex items-center gap-4 px-6 pt-4 pb-6">
        <button onClick={() => navigate(-1)} className="text-white/40 hover:text-white/70 transition-colors">
          <ArrowLeft className="w-5 h-5" />
        </button>
      </header>

      <main className="flex-1 px-5 pb-28 overflow-y-auto">
        {/* Apparence */}
        <div className="glass-card p-5 space-y-4">
          <p className="text-sm font-medium text-white/70">Apparence</p>
          <div className="grid grid-cols-3 gap-3">
            {themeOptions.map((opt) => (
              <button
                key={opt.key}
                onClick={() => setThemePreference(opt.key)}
                className={`p-4 rounded-xl flex flex-col items-center gap-2 transition-all duration-200 ${
                  themePreference === opt.key
                    ? 'border border-white/25'
                    : 'border border-transparent'
                }`}
                style={{
                  background: themePreference === opt.key
                    ? 'rgba(255,255,255,0.12)'
                    : 'rgba(255,255,255,0.04)',
                }}
              >
                <opt.icon className={`w-6 h-6 ${themePreference === opt.key ? 'text-white/90' : 'text-white/30'}`} />
                <span className={`text-xs ${themePreference === opt.key ? 'text-white/80' : 'text-white/30'}`}>
                  {opt.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
